import { render, staticRenderFns } from "./DFMateriality.vue?vue&type=template&id=46eab900&"
import script from "./DFMateriality.vue?vue&type=script&lang=js&"
export * from "./DFMateriality.vue?vue&type=script&lang=js&"
import style0 from "./DFMateriality.vue?vue&type=style&index=0&id=46eab900&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports